import { render, staticRenderFns } from "./polutionPart.vue?vue&type=template&id=76dd3f04&scoped=true&"
import script from "./polutionPart.vue?vue&type=script&lang=js&"
export * from "./polutionPart.vue?vue&type=script&lang=js&"
import style0 from "./polutionPart.vue?vue&type=style&index=0&id=76dd3f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd3f04",
  null
  
)

export default component.exports